export const customButtonTheme = {
    button: {
      color: {
        primary: "bg-secondary hover:bg-sky-900 text-white",
      },
    },
  };